import { createStore } from 'vuex'
import authModule from './modules/auth'
import Pages from './modules/pages'

const store = createStore({
  state () {
    return {
      appName: process.env.VUE_APP_NAME,
    }
  },
  mutations: {

  },
  actions: {

  },
  getters: {
    getAppName: (state) => state.appName,
  },

  modules: {
    auth: authModule,
    pages: Pages,
  }
})

export default store